import { useEffect } from "react";

export function usePageTitle(...parts: string[]): void {
  const title = [...parts, "Amber"].join(" · ");
  useEffect(() => {
    document.title = title;
  }, [title]);
}
